import { render, staticRenderFns } from "./FindShipment.vue?vue&type=template&id=946a44d2"
import script from "./FindShipment.vue?vue&type=script&lang=js"
export * from "./FindShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports